import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-events',
  standalone: true,
  templateUrl: './help-events.component.html',
  styleUrls: ['./help-events.component.css'],
})
export class HelpEventsComponent {
  readonly parent = input.required<HelpComponent>();
}
